import { useState } from 'react';
import { Trash2, AlertTriangle } from 'lucide-react';
import { dbClear } from '../lib/db';
import { fill } from '../lib/license';

const KEYS = ['giss_company_logo', 'giss_material_prices', 'giss_addr_recent', 'giss_pit_prices'];

export default function DataReset({ t }) {
  const [open, setOpen] = useState(false);
  const [word, setWord] = useState('');
  const [busy, setBusy] = useState(false);
  const go = async () => {
    setBusy(true);
    await dbClear();
    KEYS.forEach((k) => localStorage.removeItem(k));
    sessionStorage.setItem('giss_reset_done', '1');
    window.location.reload();
  };
  return (
    <section className="set-sec reset-sec" data-testid="data-reset-section">
      <h5><AlertTriangle size={14} /> {t.resetTitle}</h5>
      <p className="muted small-hint">{t.resetInfo}</p>
      {!open ? (
        <button className="btn btn-red btn-sm" data-testid="data-reset-btn" onClick={() => setOpen(true)}><Trash2 size={15} /> {t.resetBtn}</button>
      ) : (
        <div className="reset-confirm" data-testid="data-reset-confirm">
          <label htmlFor="data-reset-input">{fill(t.resetConfirm, { w: t.resetWord })}</label>
          <div className="row">
            <input id="data-reset-input" data-testid="data-reset-input" value={word} autoComplete="off" onChange={(e) => setWord(e.target.value)} />
            <button className="btn btn-red btn-sm" data-testid="data-reset-confirm-btn" disabled={busy || word.trim().toUpperCase() !== t.resetWord.toUpperCase()} onClick={go}><Trash2 size={15} /> {t.resetGo}</button>
            <button className="btn btn-outline btn-sm" data-testid="data-reset-cancel-btn" onClick={() => { setOpen(false); setWord(''); }}>{t.cancel2}</button>
          </div>
        </div>
      )}
    </section>
  );
}
